import WeatherApiComp from './components/WeatherApp';

function App() {
  return <WeatherApiComp />;
}

export default App;
